/**
 * Silensia Recovery — homepage enquiry behavior.
 * Progressive, dependency-free vanilla JS. One responsibility only:
 *  Shared activation sequence for every intent CTA (Hero, header, footer, midpoint,
 *  journey — all carry class js-silensia-enquiry-cta): once the browser's own native
 *  #enquiry anchor navigation happens, transfer focus to the Enquiry heading on the next
 *  frame and set the single seal to its static "activated" state, at most once per page
 *  load. This never calls preventDefault(): the links are real anchors and work with
 *  JavaScript disabled, on the homepage and (via {{ routes.root_url }}#enquiry) from any
 *  interior page.
 *
 * No contact-method logic lives here — the enquiry form is a fixed, always-visible,
 * email-based Shopify native form with no conditional fields.
 *
 * Persistent header CTA visibility (2026-08-25 removal): the header is no longer sticky
 * (sections/silensia-header.liquid), so its CTA is static and always visible -- the
 * IntersectionObserver-driven initPersistentHeaderCta() that used to hide/reveal it
 * around the Hero CTA is removed entirely, since with the header no longer persistent
 * it served no remaining purpose. The Homepage's own floating Contact CTA
 * (snippets/silensia-floating-contact-cta.liquid, assets/silensia-homepage-interactions.js)
 * now owns that visibility behavior instead, independent of the header.
 */
(function () {
  'use strict';

  var sealActivated = false;

  function activateSeal() {
    if (sealActivated) return;
    var seal = document.querySelector('[data-silensia-seal]');
    if (seal) seal.setAttribute('data-silensia-seal-state', 'activated');
    sealActivated = true;
  }

  function focusEnquiryHeading() {
    var heading = document.getElementById('enquiry-heading');
    if (!heading) return;
    // Deferred one frame so it never races the browser's own native anchor-jump.
    window.requestAnimationFrame(function () {
      heading.focus({ preventScroll: true });
    });
  }

  // Runs only when #enquiry actually exists on the current page (the homepage). Never
  // prevents default: the browser's native anchor navigation (URL fragment update +
  // scroll, respecting #enquiry's scroll-margin-block-start) always happens on its own.
  function onIntentCtaClick() {
    if (!document.getElementById('enquiry')) return;
    focusEnquiryHeading();
    activateSeal();
  }

  function initCtas() {
    var ctas = document.querySelectorAll('.js-silensia-enquiry-cta');
    for (var i = 0; i < ctas.length; i++) {
      ctas[i].addEventListener('click', onIntentCtaClick);
    }
  }

  // Arriving on the homepage via a cross-page CTA (interior page -> {{ routes.root_url }}#enquiry)
  // is still a genuine intent-CTA activation, just completed across a full page load.
  function initHashArrival() {
    if (window.location.hash === '#enquiry' && document.getElementById('enquiry')) {
      focusEnquiryHeading();
      activateSeal();
    }
  }

  function init() {
    initCtas();
    initHashArrival();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
